"use client";
import { useContext, useState } from "react";

import Caroussel from "@/components/caroussel";
import SellsForm from "@/components/sells-form";

import card1 from "@/assets/reviews/card-1.svg";
import card2 from "@/assets/reviews/card-2.svg";
import card3 from "@/assets/reviews/card-3.svg";
import card4 from "@/assets/reviews/card-4.svg";

import Container from "@/components/ui/Container";
import Accordion from "@/components/ui/accordion";
import { useRouter } from "next/navigation";

import { validateForm } from "@/lib/validation";
import { languageContext } from "@/contexts/language-context";
import popcardReviews from "@/translation/order/popcardReviews";
/* import { encryptQueryParams } from "@/lib/cryptage"; */
import { useCheckout } from "@/contexts/checkout-context";
import useStoreParamsCookies from "@/hooks/useStoreParamsCookies";

const CAROUSSEL_ITEMS = [
  {
    image: card1,
  },
  {
    image: card2,
  },
  {
    image: card3,
  },

  {
    image: card4,
  },
];

const FAQ: any = [
  {
    title: {
      fr: "Popcard",
      ar: "Popcard",
      en: "Popcard",
    },
    description: {
      fr: "La Popcard est fabriquée en plastique recyclé avec une puce NFC embarquée. Sa finition mate avec un logo imprimé en 3D lui donne une sensation premium la plus classe du marché.",
      ar: "Popcard مصنوعة من البلاستيك المُعاد تدويره ومزودة بشريحة NFC مدمجة. يمنحها الطلاء غير اللامع مع شعار مطبوع بتقنية ثلاثية الأبعاد إحساسًا فاخرًا وأنيقًا لا مثيل له في السوق.",
      en: "The Popcard is made from recycled plastic with an embedded NFC chip. Its matte finish with a 3D-printed logo gives it the most premium, classy feel on the market.",
    },
  },
  {
    title: {
      fr: "Le Profil Popcard",
      ar: "الملف الشخصي لـ Popcard",
      en: "The Popcard Profile",
    },
    description: {
      fr: (
        <>
          Une fois que vous avez reçu votre carte, vous pouvez la toucher ou la
          scanner avec votre smartphone. Un lien s’ouvrira avec la plateforme
          d’évaluation sur laquelle vous êtes présent.
          <br />
          <br />
          Au moment de votre commande, nous aurons seulement besoin de votre nom
          d&apos;entreprise (ou profession), de votre logo en bonne qualité et
          de la page d&apos;évaluation d&apos;avis que vous souhaitez mettre sur
          la carte.
          <br />
          <br />
          Il ne vous reste plus qu’à présenter la carte à vos clients pour la
          scanner soit par NFC ou Qr-Code et collecter leurs avis.
          <br />
          <br />
          Exemple des plateformes d’évaluation :
          <br />
          - Google Reviews
          <br />
          - Trip Advisor
          <br />
          - Airbnb
          <br />- Trustpilot ...
        </>
      ),
      ar: (
        <>
          بمجرد استلامك للبطاقة، يمكنك لمسها أو مسحها ضوئيًا بهاتفك الذكي. سيفتح
          رابط للمنصة التقييم التي أنت موجود عليها.
          <br />
          <br />
          عند تقديم طلبك، سنحتاج فقط إلى اسم شركتك (أو مهنتك)، وشعارك بجودة
          جيدة، وصفحة التقييم التي ترغب في وضعها على البطاقة.
          <br />
          <br />
          كل ما عليك فعله هو تقديم البطاقة لعملائك لمسحها إما عبر NFC أو رمز QR
          وجمع آرائهم.
          <br />
          <br />
          أمثلة على منصات التقييم:
          <br />
          - مراجعات جوجل
          <br />
          - Trip Advisor
          <br />
          - Airbnb
          <br />- Trustpilot ...
        </>
      ),
      en: (
        <>
          Once you receive your card, you can tap or scan it with your
          smartphone. A link will open to the review platform where you are
          listed.
          <br />
          <br />
          At the time of your order, we only need your company name (or
          profession), a high-quality logo, and the review page you want to
          feature on the card.
          <br />
          <br />
          All you have to do is present the card to your customers for them to
          scan via NFC or QR code and collect their feedback.
          <br />
          <br />
          Examples of review platforms:
          <br />
          - Google Reviews
          <br />
          - Trip Advisor
          <br />
          - Airbnb
          <br />- Trustpilot ...
        </>
      ),
    },
  },
  {
    title: {
      fr: "La livraison",
      ar: "التوصيل",
      en: "Delivery",
    },
    description: {
      fr: "Une fois votre commande validée, vous serez livré en un délai de 24H à 48H partout au Maroc.",
      ar: "بمجرد تأكيد طلبك، ستتم التوصيل خلال مدة تتراوح بين 24 إلى 48 ساعة في جميع أنحاء المغرب.",
      en: "Once your order is confirmed, delivery will take 24 to 48 hours anywhere in Morocco.",
    },
  },
];

const PRODUCT = "reviews";
const Reviews = ({ params }: { params: any }) => {
  // store utm inside cookies
  useStoreParamsCookies(params);
  const { lang } = useContext<any>(languageContext);
  const router = useRouter();
  const [, setCheckout] = useCheckout();
  const [fields, setFields] = useState<any>({
    fullName: {
      label: {
        fr: "Nom et Prénom*",
        ar: "الاسم الكامل *",
        en: "Full Name*",
      },
      name: "Nom et Prénom",
      placeholder: {
        fr: "Votre nom et prénom",
        ar: "أدخل إسمك الكامل",
        en: "Your full name",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    enterprise: {
      name: "Entreprise ou Métier",
      label: {
        fr: "Entreprise ou Métier",
        ar: "الشركة أو الأعمال *",
        en: "Company or Profession*",
      },
      placeholder: {
        fr: "Entreprise ou Métier",
        ar: "الشركة أو الأعمال",
        en: "Company or profession",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    email: {
      name: "",
      label: {
        fr: "Adresse Email*",
        ar: "البريد الإلكتروني *",
        en: "Email Address*",
      },
      placeholder: {
        fr: "Votre email",
        ar: "أدخل بريدك الإلكتروني",
        en: "Your email",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    phone: {
      label: { fr: "Téléphone*", ar: "الهاتف", en: "Phone*" },
      placeholder: {
        fr: "Votre Téléphone",
        ar: "أدخل رقم هاتفك",
        en: "Your phone number",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    address: {
      name: "Adresse",
      label: {
        fr: "Adresse Exacte *",
        ar: "العنوان*",
        en: "Exact Address*",
      },
      placeholder: {
        fr: "Votre adresse exacte",
        ar: "أدخل عنوانك",
        en: "Your exact address",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    city: {
      name: "Ville",
      label: {
        fr: "Ville *",
        ar: "المدينة *",
        en: "City*",
      },
      placeholder: {
        fr: "Votre ville exacte",
        ar: "أدخل مدينتك",
        en: "Your city",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
    qty: {
      label: {
        fr: "Quantité*",
        ar: "الكمية *",
        en: "Quantity*",
      },
      placeholder: {
        fr: "Votre nom et prénom",
        ar: "أدخل إسمك الكامل",
        en: "Your full name",
      },
      value: 1,
      type: "increment",
      error: { fr: "", ar: "", en: "" },
    },
    color: {
      name: "color",
      label: { fr: "Couleur", ar: "اللون", en: "Color" },
      placeholder: "",
      value: "white",
      error: { fr: "", ar: "", en: "" },
    },
    promoCode: {
      name: "coupon",
      label: {
        fr: "Code Promo",
        ar: "كوبون",
        en: "Promo Code",
      },
      placeholder: {
        fr: "Votre code Promo",
        ar: "كوبون",
        en: "Your promo code",
      },
      value: "",
      error: { fr: "", ar: "", en: "" },
    },
  });

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const isValidationError = await validateForm(
      fields,
      setFields,
      [
        "promoCode",
        "email",
        "phone",
        "city",
        "address",
        "enterprise",
        "fullName",
      ],
      "reviews"
    );

    if (isValidationError) {
      return;
    }
    const data: any = {};
    Object.keys(fields).forEach((key) => {
      data[key] = fields[key].value;
    });

    setCheckout({ ...data, product: PRODUCT });
    router.push("/checkout");
    /* const objectToDcrypt: any = {};
    Object.keys(fields).forEach((key) => {
      objectToDcrypt[key] = fields[key].value;
    });

    const crypt = encryptQueryParams({
      ...objectToDcrypt,
      product: PRODUCT,
    });

    let url = `/checkout?query=${encodeURIComponent(crypt)}`;
    router.push(url); */
  };
  return (
    <>
      <Container className="grid grid-cols-12 gap-8 justify-items-center py-[5rem] px-0  overflow-x-hidden">
        <div className="col-span-12 sm:col-span-6 flex flex-col gap-8 w-full max-w-full px-4 ">
          <Caroussel items={CAROUSSEL_ITEMS} className="w-full self-stretch" />
          <div className="flex flex-col gap-4 mt-4 max-sm:hidden">
            {FAQ.map((f: any, index: number) => {
              return (
                <Accordion
                  title={f.title[lang]}
                  description={f.description[lang]}
                  key={index}
                />
              );
            })}
          </div>
        </div>
        <SellsForm
          onSubmit={onSubmit}
          fields={fields}
          setFields={setFields}
          className="col-span-12 sm:col-span-6 mx-4"
          name={popcardReviews.title}
          description={popcardReviews.description}
          whatsappMessage
          checked={[
            popcardReviews.ameliore,
            popcardReviews.collectAvis,
            popcardReviews.feedBack,
            popcardReviews.compatible,
            popcardReviews.qrCodeImprime,
            popcardReviews.Pesonalization,
          ]}
          unchecked={[]}
          colors={[
            {
              value: "white",
              color: "#fff",
              name: { fr: "Blanche", ar: "أبيض", en: "White" },
            },
            {
              value: "silver",
              color: "#c8d6e5",
              name: { fr: "Argent", ar: "فضي", en: "Silver" },
            },
            {
              value: "gold",
              color: "#f9ca24",
              name: { fr: "Dorée", ar: "ذهبي", en: "Gold" },
            },
          ]}
          oldPrice={290}
          currentPrice={190}
          isMetrics={false}
        />
        <div className="col-span-12 flex flex-col gap-4 w-full md:hidden px-4">
          {FAQ.map((f: any, index: number) => {
            return (
              <Accordion
                title={f.title[lang]}
                description={f.description[lang]}
                key={index}
              />
            );
          })}
        </div>
      </Container>
    </>
  );
};

export default Reviews;
